/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Tick = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 8 7">
      <path transform="translate(0 -3)" d="M2.19545507,9.79416034 L0.195495999,7.69386505 C-0.0651653331,7.42012656 -0.0651653331,6.97766435 0.195495999,6.70392587 C0.456157332,6.43018738 0.877482044,6.43018738 1.13814338,6.70392587 L2.62877954,8.26934596 L6.82736029,3.24333932 C7.06735538,2.94929798 7.48801343,2.91569326 7.7666744,3.16702859 C8.04666867,3.41906403 8.07933467,3.86012604 7.83933958,4.15346728 L3.17276841,9.75425473 C3.05210421,9.9026756 2.87744112,9.990888 2.69211158,9.99858908 C2.49011571,9.99928918 2.32011919,9.92577885 2.19545507,9.79416034 Z" />
    </BaseSvgIcon>
  )
}

export default Tick
